import React, { useEffect, useState } from 'react';
import { ADDITIONAL_DETAILS_FORM, ADDITIONAL_DETAILS_FORM_II_DISABLED } from '../../Payment/EstatePayment.const';
import { FieldArray, useFormikContext } from 'formik';
import GenericFormCard from '../../../../../components/moduleCommonFormik/GenericFormCard.component';
import { trash } from '../../../../../utils/Logo';
import { t } from 'i18next';
import { getType } from '../../EstateManagement.controller';
import { BankDetailReadOnly, ExistingBlokAndFloorDetailsReadOnly, ExistingMortgageReadOnly, NOCReadOnly, OwnershipReadOnly, ProposedActivityReadOnly } from '../ReadOnlyTables';
import { CONSTANT_DATA_FIELD } from '../../../../../utils/constants';

function RevertAdditionalDetails(props: any) {
    const { fieldsDropdown, onRemoveAdditionalDetails, applicationReverted, dropdownData } = props;
    const { values } = useFormikContext<any>();

    const [tableType, setTableType] = useState<any>([]);
    const [formData, setFormData] = useState<any>([{ formData: [] }]);

    console.log('props', props);

    useEffect(() => {
        let form: any = [];
        values.additionalDetails?.map((item: any) => {
            if (item?.type === 'TABLE_DATA') {
                setTableType([...tableType, item.code]);
            } else {
                form = [
                    ...form,
                    {
                        title: item?.description,
                        field: item.code,
                        type: getType(item?.type),
                        isRequired: true,
                        multiSelect: item?.type === 'MULTI_DROPDOWN' ? true : undefined,
                        isDisabled: true,
                        options:
                            item.type === 'RADIO'
                                ? [
                                      { value: true, title: 'Yes' },
                                      { value: false, title: 'No' }
                                  ]
                                : undefined
                    }
                ];
            }
        });
        setFormData(form);
    }, []);

    const removeAdditionalData = async (ind: any, data: any, remove: any) => {
        await onRemoveAdditionalDetails(ind, data, remove);
        const pendingAdditionalData = values?.additionalDetails?.filter((val: any) => val?.status !== 'CLOSED');
        if (pendingAdditionalData?.length <= 1) {
            window.location.reload();
        }
    };

    const getAdditionalDetailsForm = (data: any) => {
        return ADDITIONAL_DETAILS_FORM.map((val: any) => {
            const modifiedFormData =
                val.formData?.map((item: any) => ({
                    ...item,
                    isDisabled: data.status === 'CLOSED' || !values?.isUpdatable
                })) || [];

            if (data.status === 'CLOSED') {
                modifiedFormData.push(
                    {
                        title: 'Requested Date',
                        field: 'requestedDate',
                        type: CONSTANT_DATA_FIELD.TEXT_FIELD,
                        isDisabled: true
                    },
                    {
                        title: 'Response Date',
                        field: 'respondedDate',
                        type: CONSTANT_DATA_FIELD.TEXT_FIELD,
                        isDisabled: true
                    }
                );
            }

            return {
                ...val,
                formData: modifiedFormData
            };
        });
    };

    console.log('formData', formData, applicationReverted);

    return (
        <>
            <form className='scroll-focus'>
                <FieldArray name='additionalDetails'>
                    {({ remove, push }) => (
                        <div>
                            {values.additionalDetails?.length > 0 &&
                                values.additionalDetails.map((data: any, index_p: number) => (
                                    <div
                                        className='row mx-1'
                                        key={index_p}
                                        style={{ boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)', border: '1px solid rgb(218, 218, 218)', borderRadius: '25px', position: 'relative', marginTop: '2.5rem' }}
                                    >
                                        <div className='col-sm-12 align-items-center pb-2'>
                                            <div className='mx-3 my-2'>
                                                <div className='d-flex justify-content-end  mx-3'>
                                                    {applicationReverted && data.status !== 'CLOSED' && (
                                                        <img
                                                            style={{
                                                                cursor: 'pointer',
                                                                zIndex: 1,
                                                                padding: '6px',
                                                                height: '35px',
                                                                borderRadius: '6px',
                                                                position: 'absolute',
                                                                right: '10px',
                                                                top: '5px'
                                                            }}
                                                            onClick={() => removeAdditionalData(index_p, data, remove)}
                                                            src={trash}
                                                            alt='delete'
                                                        />
                                                    )}
                                                </div>

                                                {getAdditionalDetailsForm(data).map((val: any, _: number) => (
                                                    <GenericFormCard fieldPath={`additionalDetails.${index_p}`} {...val} dropdownOptions={fieldsDropdown} />
                                                ))}
                                                {data.status === 'CLOSED' && (
                                                    <>
                                                        <>
                                                            {data.type !== 'TABLE_DATA' ? (
                                                                <GenericFormCard
                                                                    key={`dropdown-${index_p}`}
                                                                    fieldPath={`additionalDetails.${index_p}`}
                                                                    formData={[formData.find((item: any) => item.field === data.code)]}
                                                                    dropdownOptions={dropdownData}
                                                                />
                                                            ) : (data.code === 'ENTERPRISE_NIC_PROPOSED_ACTIVITY' || data.code === 'NIC_PROPOSED_ACTIVITY') && data.status === 'CLOSED' ? (
                                                                <div className='mx-3'>
                                                                    <ProposedActivityReadOnly index={index_p} />
                                                                </div>
                                                            ) : (data.code === 'APPLICANT_OWNER' || data.code === 'OWNER_CHANGE_DATA') && data.status === 'CLOSED' ? (
                                                                <div className='mx-3'>
                                                                    <OwnershipReadOnly index={index_p} dropdownData={dropdownData} />
                                                                </div>
                                                            ) : data.code === 'NOC_FROM_BANK' && data.status === 'CLOSED' ? (
                                                                <div className='mt-3 p-3' style={{ border: '1px solid rgb(218, 218, 218)', borderRadius: '25px' }}>
                                                                    <NOCReadOnly index={index_p} />
                                                                </div>
                                                            ) : data.code === 'EXISTING_MORTGAGE_DETAILS' && data.status === 'CLOSED' ? (
                                                                <div className='mt-3'>
                                                                    <ExistingMortgageReadOnly index={index_p} />
                                                                </div>
                                                            ) : data.code === 'CURRENT_BANK_DETAILS' && data.status === 'CLOSED' ? (
                                                                <div className='mt-3'>
                                                                    <BankDetailReadOnly index={index_p} />
                                                                </div>
                                                            ) : data.code === 'BPA_BLOCK_FLOOR_DATA' && data?.status === 'CLOSED' ? (
                                                                <ExistingBlokAndFloorDetailsReadOnly floorData={{ blocks: data?.response }} />
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </>

                                                        {ADDITIONAL_DETAILS_FORM_II_DISABLED.map((val: any, _: number) => (
                                                            <GenericFormCard fieldPath={`additionalDetails.${index_p}`} {...val} />
                                                        ))}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            {applicationReverted && (
                                <button className='col-sm-12 my-4 justify-content-center align-items-center noc_add_fields' type='button' onClick={() => push({ fieldName: '', remarks: '' })}>
                                    + {t('ADD_', ' Add More')}
                                </button>
                            )}
                        </div>
                    )}
                </FieldArray>
            </form>
        </>
    );
}

export default RevertAdditionalDetails;
